import { toast } from "@/hooks/use-toast"

/**
 * Show a success toast notification
 */
export function showSuccessToast(message: string, description?: string) {
  toast({
    title: message,
    description,
    variant: "default",
  })
}

/**
 * Show an error toast notification
 */
export function showErrorToast(message: string, description?: string) {
  toast({
    title: message,
    description,
    variant: "destructive",
  })
}
